import { createNativeRequest, platform } from '@mx/core';
import type { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import type { IGetWebMirrorConfigReq, IGetWebMirrorConfigResp } from '../types/mirror';

export const postGetWebMirrorConfig = async (
  data: IGetWebMirrorConfigReq,
  config?: AxiosRequestConfig
): Promise<IGetWebMirrorConfigResp> => {
  const url = '/weaver/api/v1/mirror/config';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetWebMirrorConfigResp>({
      method: 'POST',
      url,
      data,
    });
  }

  return await request.post(url, data, config);
};
